import * as endpoints from './endpoints';

const PathwayService = { ...endpoints };

export default PathwayService;
export type { CarePathwayPreset, ResolvePathwayInput, ApplyPathwayInput } from './endpoints';
